// deps
// eslint-disable-next-line import/no-unresolved
import Router from "@splitfire-agency/raiden-library/dist/libraries/RouterImplementation/Router";
// eslint-disable-next-line import/no-unresolved
import Uri from "@splitfire-agency/raiden-library/dist/libraries/Uri";

export const frontBaseUri = new Uri(
  // @ts-ignore
  process.env.NEXT_PUBLIC_FRONT_SCHEME,
  null,
  process.env.NEXT_PUBLIC_FRONT_HOST,
  null,
  null,
  null,
  null,
);

export const frontBaseUriWithBasePath = new Uri(
  // @ts-ignore
  process.env.NEXT_PUBLIC_FRONT_SCHEME,
  null,
  process.env.NEXT_PUBLIC_FRONT_HOST,
  null,
  process.env.NEXT_PUBLIC_FRONT_BASE_PATH,
  null,
  null,
);

/**
 * Build a router.
 * @param {import ("@splitfire-agency/raiden-library/dist/libraries/Uri").default} baseUri
 * @return {import ("@splitfire-agency/raiden-library/dist/libraries/RouterImplementation/Router").default})}
 */
function buildRouter(baseUri) {
  const frontRouter = new Router();

  frontRouter.group(baseUri, (frontRouter) => {
    // assets (previewer)
    frontRouter
      .get("/public/<filePath>")
      .setId("@front.assets")
      .setConstraint("filePath", /.*/);

    // internal assets (nextjs)
    frontRouter
      .get("/<filePath>")
      .setId("@front.internal-assets")
      .setConstraint("filePath", /.*/);

    frontRouter.get("/").setId("@front.home");

    frontRouter.get("/actualites/<postSlug>").setId("@front.article");

    frontRouter.get("/le-cabinet").setId("@front.leCabinet");

    frontRouter.get("/notre-role").setId("@front.notreRole");

    frontRouter.get("/references").setId("@front.references");

    frontRouter.get("/pages/<postSlug>").setId("@front.page");

    frontRouter.get("/contact").setId("@front.contact");

    frontRouter.group("/api", (frontRouter) => {
      frontRouter
        .get("/translation-messages")
        .setId("@front.api.translation-messages");
    });
  });

  return frontRouter;
}

export const frontRouter = buildRouter(frontBaseUri);
export const frontRouterWithBasePath = buildRouter(frontBaseUriWithBasePath);
